import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../redux/actions/AuthenticationActions';
import { isValidEmail } from '../../lib/utils';

import SplitPageContainer from '../commonComponents/shared/SplitPageContainer';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import FadeoutErrorMessage from '../commonComponents/util/FadeOutErrorMessage';
import ValidatedInput from '../commonComponents/util/ValidatedInput';

class PasswordRecoverPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            validEmail: false,
            submitted: false
        };

        this.onChange = this.onChange.bind(this);
        this.submitEmail = this.submitEmail.bind(this);
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    validateEmail(email) {
        const validEmail = isValidEmail(email);
        this.setState({ validEmail: validEmail });
        return validEmail;
    }

    async submitEmail() {
        await this.props.actions.recoverPassword(this.state.email);

        if (this.props.success)
            this.setState({ submitted: true });
    }

    render() {
        return (
            <SplitPageContainer
                title="Password Recovery"
                subtitle="Enter your email address and we will send you a link to reset your password.">
                {this.state.submitted ? <div className="password-recovery">
                    <p>Sent!</p>
                    <p>An email has been sent to {this.state.email}, check your inbox for instructions on how to reset your password.</p>
                </div> : <div>
                        {(this.props.location.state && this.props.location.state.expiredResetTokenRedirect) &&
                            <span className="error-label error-label-margin-bottom">Your reset password link has expired.  Please enter your email to receive a new link to reset your password.</span>}
                        <ValidatedInput input={<input type="text"
                            onKeyDown={e => {if (e.key === 'Enter' && this.state.email) if (this.validateEmail(this.state.email)) this.submitEmail();}} />}
                            label="Enter Email Address" name="email" value={this.state.email} onChange={this.onChange}
                            validated={true} showValidationError={this.state.email} validate={this.validateEmail.bind(this)} 
                            errorMessage="Invalid Email Address"/>
                        <div className="left-column-footer relative">
                            {this.props.loading ? <LoadingSpinner height="32" /> :
                                <button className="btn btn-primary btn-wide" onClick={this.submitEmail}
                                    disabled={!this.state.email || !this.state.validEmail}>Reset</button>}

                            <FadeoutErrorMessage show={!this.props.success} />
                        </div>
                    </div>}
            </SplitPageContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.authentication.recoverPassword
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordRecoverPage);



// WEBPACK FOOTER //
// ./src/components/authenticationComponents/PasswordRecoveryPage.jsx